import {Component, OnInit} from '@angular/core';
import { ScrollService } from '../../lib/services/scroll/scroll.service';


@Component({
  selector: 'app-search-page',
  templateUrl: './search-page.component.html',
  styleUrls: ['./search-page.component.scss']
})
export class SearchPageComponent implements OnInit {

  constructor(protected scroll: ScrollService) { }

  ngOnInit() {
    this.scroll.scrollToContentOnNavigationEnd();
  }

}
